import { SideEnum, type LegDirectionEnum } from '@talos/kyoko';

/** Resolves a leg's effective side relative to the parent multileg order side. */
export function getMultilegLegSide(orderSide: SideEnum, legDirection: LegDirectionEnum | undefined): SideEnum {
  const oppositeSide = orderSide === SideEnum.Buy ? SideEnum.Sell : SideEnum.Buy;
  return legDirection === 'Opposite' ? oppositeSide : orderSide;
}
